<cdk-virtual-scroll-viewport itemSize="1" class="tw-w-[200px] tw-h-full" style="border-right: 1px solid lightgrey;">
    <mat-button-toggle-group [hideSingleSelectionIndicator]="true" class="tw-flex tw-flex-col tw-border-0" value={{selectedValue}}>
        <ng-container *ngFor="let option of options | keyvalue">
            <mat-button-toggle value={{option.value}} (click)="onItemClick(option)">
                <span translate={{option.value}}></span>
            </mat-button-toggle>
        </ng-container>
    </mat-button-toggle-group>
</cdk-virtual-scroll-viewport>
